import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'
import _ from 'lodash'

export default class Flag extends PureComponent {
    static propTypes = {
        country: PropTypes.string.isRequired,
    }

    render() {
        const { country } = this.props

        if (_.isEmpty(country)) return null

        return <div className={cx('flag-icon', `flag-icon-${`${country}`.toLowerCase()}`)} />
    }
}
